import React from "react";

export function EmptyValue() {

    return (
        <div style={{
            borderRadius: "9999px",
            backgroundColor: "rgba(0,0,0,0.05)",
            width: "18px",
            height: "6px",
            display: "inline-block"
        }}>
        </div>
    );
};
